<template>
  <p class="interest-text"><span>{{$store.getters.translations.from}}</span> {{ interest }} %</p>
  <p class="interest-sub-text">{{$store.getters.translations.effective_annual_interest}}</p>
</template>
<script>
export default {
  props:[
      'interest'
  ],
  name: "interest-information",
  data(){
    return {

    }
  }
}
</script>

<style scoped>

</style>
